import React, { Fragment, useEffect, useRef, useState } from 'react';
import { Form, Input, Select } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import ReactDOM from 'react-dom';
import PhoneInput from '../components/PhoneInput';
import COUNTRY from 'country-json/src/country-by-abbreviation.json';
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";

export default (formPlugin, namespace) => {

    return {
        Renderer: (props) => {

            var identity = formPlugin.formData.identity

            let containerRef = useRef(null)
            const [listField, setlistField] = useState(null)
            useEffect(() => {
                setlistField(props.pluginConfig.getListField(containerRef.current))
            }, [])

            if (props.remove) {
                formPlugin.onAddFormPlugin(props, props.nodeId, props.pluginConfig.id)
            }
            const { data } = props

            if (!identity || identity === "NONE") {
                if (props.remove) {
                    props.remove()
                }
                return null
            }

            const isManual = formPlugin.formData?.manual || false
            var reducedWidth = data.reduced ? "48%" : "100%"
            const listFieldProps = listField ? { ...listField, key: undefined } : null

            return (
                <div ref={(ref) => containerRef.current = ref}>

                    <Form.Item noStyle shouldUpdate={true}>
                        {(_form) => {

                            var fixedGenre = false
                            if (data.fixedGenre === "Homme" || data.fixedGenre === "Femme") {
                                fixedGenre = true
                                let fixedValue = data.fixedGenre === "Homme"
                                if (_form.getFieldValue(["identity", "homme"]) !== fixedValue) {
                                    _form.setFieldValue(["identity", "homme"], fixedValue)
                                }
                            }

                            return (
                                <Form.Item
                                    {...listFieldProps}
                                    label={t`Civilité` + " :"}
                                    name={["identity", "homme"]}
                                    rules={[{
                                        required: !isManual,
                                        message: t`Ce champ est obligatoire`
                                    }]}
                                >
                                    <Select disabled={fixedGenre} size="large" placeholder={t`Civilité`}>
                                        <Select.Option value={true}><Trans>Monsieur</Trans></Select.Option>
                                        <Select.Option value={false}><Trans>Madame</Trans></Select.Option>
                                    </Select>
                                </Form.Item>
                            )
                        }}
                    </Form.Item>

                    <div style={{ display: data.reduced ? "flex" : "block", justifyContent: "space-between" }}>

                        <Form.Item
                            {...listFieldProps}
                            label={(data.labelPrenom || t`Prénom`) + " :"}
                            name={["identity", "prenom"]}
                            rules={[{
                                required: !isManual,
                                message: t`Ce champ est obligatoire`
                            }, {
                                pattern: new RegExp(/^[A-zÀ-ú\s]*$/),
                                message: t`Le champ doit contenir uniquement des lettres`
                            }]}
                            style={{ width: reducedWidth }}
                        >
                            <Input type="text" placeholder={data.labelPrenom || t`Prénom`} autoComplete="given-name" />
                        </Form.Item>

                        <Form.Item
                            {...listFieldProps}
                            label={(data.labelNom || t`Nom`) + " :"}
                            name={["identity", "nom"]}
                            rules={[{
                                required: !isManual,
                                message: t`Ce champ est obligatoire`
                            }, {
                                pattern: new RegExp(/^[A-zÀ-ú\s]*$/),
                                message: t`Le champ doit contenir uniquement des lettres`
                            }]}
                            style={{ width: reducedWidth }}
                        >
                            <Input type="text" placeholder={data.labelNom || t`Nom`} autoComplete="family-name" />
                        </Form.Item>

                    </div>

                    <div style={{
                        display: (data.reduced && props.device === "DESKTOP") ? "flex" : "block",
                        justifyContent: "space-between"
                    }}>
                        <Form.Item
                            {...listFieldProps}
                            label={(data.labelEmail || t`Email`) + " :"}
                            name={["identity", "email"]}
                            rules={[{
                                required: !isManual,
                                message: t`Ce champ est obligatoire`
                            }, {
                                pattern: new RegExp(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/),
                                message: t`L'adresse email n'est pas valide`
                            }]}
                            style={{ width: (data.reduced && props.device === "DESKTOP") ? reducedWidth : "100%" }}
                        >
                            <Input type="email" placeholder={data.labelEmail || t`Email`} autoComplete="email" />
                        </Form.Item>

                        <Form.Item
                            {...listFieldProps}
                            label={(data.labelTel || t`Téléphone`) + " :"}
                            name={["identity", "tel"]}
                            rules={[{
                                required: !isManual,
                                message: t`Ce champ est obligatoire`
                            }, { validator: (_, _value) => !isNaN(_value) ? Promise.resolve(true) : Promise.reject(t`Le numéro de téléphone est invalide`) }]}
                            style={{ width: (data.reduced && props.device === "DESKTOP") ? reducedWidth : "100%" }}
                        >
                            <PhoneInput defaultLang={props.lang} placeholder={data.labelTel || t`Téléphone`} />
                        </Form.Item>
                    </div>

                    {formPlugin.formData.identity === "FULL" && (
                        <Fragment>
                            <Form.Item
                                {...listFieldProps}
                                label={(data.labelAdresse || t`Adresse`) + " :"}
                                name={["identity", "adresse"]}
                                rules={[{
                                    required: !isManual,
                                    message: t`Ce champ est obligatoire`
                                }]}
                            >
                                <Input type="text" placeholder={data.labelAdresse || t`Adresse`} autoComplete="address-line1" />
                            </Form.Item>

                            <div style={{ display: data.reduced ? "flex" : "block", justifyContent: "space-between" }}>
                                <Form.Item
                                    {...listFieldProps}
                                    label={(data.labelPostal || t`Code Postal`) + " :"}
                                    name={["identity", "postal"]}
                                    rules={[{
                                        required: !isManual,
                                        message: t`Ce champ est obligatoire`
                                    }, {
                                        pattern: new RegExp(/^[0-9]*$/),
                                        message: t`Le champ doit contenir uniquement des chiffres`
                                    }]}
                                    style={{ width: reducedWidth }}
                                >
                                    <Input type="text" placeholder={data.labelPostal || t`Code Postal`} autoComplete="postal-code" />
                                </Form.Item>

                                <Form.Item
                                    {...listFieldProps}
                                    label={(data.labelVille || t`Ville`) + " :"}
                                    name={["identity", "ville"]}
                                    rules={[{
                                        required: !isManual,
                                        message: t`Ce champ est obligatoire`
                                    }, {
                                        pattern: new RegExp(/^[A-z0-9À-ú\s]*$/),
                                        message: t`Le champ doit contenir uniquement des lettres`
                                    }]}
                                    style={{ width: reducedWidth }}
                                >
                                    <Input type="text" placeholder={data.labelVille || t`Ville`} autoComplete="home city" />
                                </Form.Item>
                            </div>

                            <Form.Item noStyle shouldUpdate={true}>
                                {(_form) => {

                                    let pays = _form.getFieldValue(["identity", "pays"])
                                    if (!pays) {
                                        _form.setFieldValue(["identity", "pays"], COUNTRY.find(i => i.abbreviation === formPlugin.getCountry())?.country)
                                    }

                                    return (
                                        <Form.Item
                                            {...listFieldProps}
                                            label={t`Pays` + " :"}
                                            name={["identity", "pays"]}
                                            rules={[{
                                                required: !isManual,
                                                message: t`Ce champ est obligatoire`
                                            }]}
                                        >
                                            <select className={"form-control"}>
                                                <option unselectable disabled><Trans>Pays</Trans></option>
                                                {COUNTRY.map(i => {
                                                    return (
                                                        <option value={i.country}>{i.country}</option>
                                                    )
                                                })}
                                            </select>
                                        </Form.Item>
                                    )
                                }}
                            </Form.Item>

                            {data.showNote && (
                                <Form.Item
                                    {...listFieldProps}
                                    label={(data.labelNote || t`Complément d'adresse`) + " :"}
                                    name={["identity", "note_adresse"]}
                                >
                                    <Input placeholder={data.labelNote || t`Complément d'adresse`} autoComplete="address-line2" />
                                </Form.Item>
                            )}
                        </Fragment>
                    )}

                    <div className="form-field" data-field={JSON.stringify({ key: "identity", name: "identity" })}>
                        {props.children}
                    </div>

                </div>
            )
        },
        namespace: namespace,
        id: 'form-identity' + namespace,
        title: t`Block Identitaire`,
        description: t`Élément de formulaire utilisable.`,
        icon: <UserOutlined />,
        iconColor: "#138D75",
        version: 1,
        getListField: (containerRef) => {
            const listField = ReactDOM.findDOMNode(containerRef)?.closest(".form-field")?.dataset.field
            if (listField) {
                return JSON.parse(listField)
            }
            return null
        },
        cellPlugins: (plugins, data) => {
            const initialPlugins = formPlugin.getPluginsMem(namespace).filter(i => !i.id.includes("form-contact") && !i.id.includes("form-child") && !i.id.includes("form-hazkara") && !i.id.includes("form-identity") && !i.id.includes("form-product") && !i.id.includes("form-step-container") && !i.id.includes("form-submit-button") && !i.id.includes("form-free-amount") && !i.id.includes("form-paiement-method") && !i.id.includes("form-calendar"))
            return [...initialPlugins, ...formPlugin.getContactFormPlugins(namespace)]
        },
        hideInMenu: (!formPlugin.formData.identity || formPlugin.formData.identity === "NONE"),
        controls: {
            type: 'autoform',
            schema: {
                properties: {
                    reduced: {
                        type: 'boolean',
                        uniforms: {
                            label: t`Formulaire Réduit`,
                        }
                    },
                    labelNom: {
                        type: 'string',
                        uniforms: {
                            label: t`Étiquette Nom`,
                            placeholder: t`Étiquette Nom`,
                        }
                    },
                    labelPrenom: {
                        type: 'string',
                        uniforms: {
                            label: t`Étiquette Prénom`,
                            placeholder: t`Étiquette Prénom`,
                        }
                    },
                    labelEmail: {
                        type: 'string',
                        uniforms: {
                            label: t`Étiquette Email`,
                            placeholder: t`Étiquette Email`,
                        }
                    },
                    labelTel: {
                        type: 'string',
                        uniforms: {
                            label: t`Étiquette Téléphone`,
                            placeholder: t`Étiquette Téléphone`,
                        }
                    },
                    labelAdresse: {
                        type: 'string',
                        uniforms: {
                            label: t`Étiquette Adresse`,
                            placeholder: t`Étiquette Adresse`,
                            showIf: () => formPlugin.formData.identity === "FULL"
                        }
                    },
                    labelPostal: {
                        type: 'string',
                        uniforms: {
                            label: t`Étiquette Postal`,
                            placeholder: t`Étiquette Postal`,
                            showIf: () => formPlugin.formData.identity === "FULL"
                        }
                    },
                    labelVille: {
                        type: 'string',
                        uniforms: {
                            label: t`Étiquette Ville`,
                            placeholder: t`Étiquette Ville`,
                            showIf: () => formPlugin.formData.identity === "FULL"
                        }
                    },
                    showNote: {
                        type: 'boolean',
                        uniforms: {
                            label: t`Afficher le Complément d'adresse`,
                        }
                    },
                    fixedGenre: {
                        type: "string",
                        uniforms: {
                            label: t`Fixé le genre`,
                            allowedValues: ["Choisir", "Homme", "Femme"],
                        },
                    },
                }
            },
        },
    }
}
